/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {CommunicationStrategyModel} from '../../core/_models'

type Props = {
  communicationStrategy: CommunicationStrategyModel
}

const CommunicationStrategyLinkCell: FC<Props> = ({communicationStrategy}) => {

  return(
  <div className='d-flex align-items-center'>
    <div className='d-flex flex-column'>
      <a  className='text-gray-800 text-hover-primary mb-1'>
        {communicationStrategy.link ? communicationStrategy.link : ""}
      </a>
    
    </div>
  </div>     

)}
export {CommunicationStrategyLinkCell}
